import { JsonSerializable } from '@/util/object/JsonSerializable'
import { ElementCustomizationsResponse } from '@/cowboy/reward_link/object/customization/ElementCustomizationsResponse'
import { BrandDisplayOrderResponse } from '@/cowboy/reward_link/object/customization/BrandDisplayOrderResponse'

export class DetailsResponse extends JsonSerializable {
  /** @type {string} */
  #titleText
  /** @type {string} */
  #bannerText
  /** @type {boolean} */
  #showFavorites
  /** @type {Array<ElementCustomizationsResponse>} */
  #elementCustomizations
  /** @type {Array<BrandDisplayOrderResponse>} */
  #customBrandDisplayOrder

  constructor (jsonObject) {
    super()
    this.#titleText = jsonObject.titleText
    this.#bannerText = jsonObject.bannerText
    this.#showFavorites = Boolean(String(jsonObject.showFavorites).toLowerCase() === 'true')
    this.#elementCustomizations = jsonObject.elementCustomizations?.map(elementCustomization => ElementCustomizationsResponse.fromJSON(elementCustomization)) || []
    this.#customBrandDisplayOrder = jsonObject.customBrandDisplayOrder?.map(brandDisplayOrder => BrandDisplayOrderResponse.fromJSON(brandDisplayOrder)) || []
    Object.freeze(this)
  }

  get titleText () {
    return this.#titleText
  }

  get bannerText () {
    return this.#bannerText
  }

  get showFavorites () {
    return this.#showFavorites
  }

  get elementCustomizations () {
    return this.#elementCustomizations
  }

  get customBrandDisplayOrder () {
    return this.#customBrandDisplayOrder
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      titleText: this.#titleText,
      bannerText: this.#bannerText,
      showFavorites: this.#showFavorites,
      elementCustomizations: this.#elementCustomizations?.map(elementCustomization => elementCustomization.toJSON()),
      customBrandDisplayOrder: this.#customBrandDisplayOrder?.map(brandDisplayOrder => brandDisplayOrder.toJSON())
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {DetailsResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new DetailsResponse(jsonObject)) || undefined
  }
}
